export function getToken(): string {
  return localStorage.getItem('access_token') || localStorage.getItem('token') || '';
}

export function authHeaders(): Record<string, string> {
  return {
    Authorization: 'Bearer ' + getToken(),
    'Content-Type': 'application/json',
  };
}

export function validateTaxField(key: string, value: string | null | undefined): string | null {
  if (!value || String(value).trim() === '') return null;
  const v = String(value).trim();

  // Canada
  if (key === 'ca_bn') {
    const digits = v.replace(/\D/g, '');
    if (digits.length !== 9) return 'Business number must be 9 digits';
  }
  if (key === 'ca_payroll_account') {
    if (!/^RP\d{4}$/i.test(v)) return 'Account must be RP followed by 4 digits (e.g., RP0001)';
  }
  if (key === 'ca_wsib') {
    const digits = v.replace(/\D/g, '');
    if (digits.length < 7 || digits.length > 10) return 'Account number should be 7-10 digits';
  }

  // US
  if (key === 'us_ein') {
    const digits = v.replace(/\D/g, '');
    if (digits.length !== 9) return 'EIN must be 9 digits (XX-XXXXXXX)';
  }

  // UK
  if (key === 'gb_paye_reference') {
    if (!/^\d{3}\/[A-Z0-9]+$/i.test(v)) return 'Format: 123/AB456 (3 digits, slash, letters/numbers)';
  }
  if (key === 'gb_accounts_office') {
    if (!/^\d{3}P[A-Z0-9]{8}$/i.test(v)) return 'Format: 123PX00123456 (3 digits, P, 8 chars)';
  }

  // Australia
  if (key === 'au_abn') {
    const digits = v.replace(/\D/g, '');
    if (digits.length !== 11) return 'ABN must be 11 digits';
  }

  return null;
}